module.exports = __webpack_public_path__ + "img/ina-hf.239fad83.png";